<template>
    <div class="wechat-share"></div>
</template>

<script>
    export default {
        name: "wechatShare",
        data() {
            return {};
        },
        created() {
            this.getJsapiTicket();
        },
        methods: {
            getJsapiTicket(){
                var that = this;
                that.$get('qiubi/share',{
                    url:window.location.href.split('#')[0]
                })
                    .then(res=>{
                        if(res.code===200){
                            var wechat_data = JSON.parse(res.data);
                            var wechat_share_data={
                                appId:wechat_data.appId,
                                timestamp:wechat_data.timestamp,
                                nonceStr:wechat_data.nonceStr,
                                signature:wechat_data.signature,
                                title:that.$route.meta.title,
                                imgUrl:'https://xy.instqr.com/qiubih5/img/fenx-tub.png',
                                link:window.location.href,
                                desc:'与丘比一起健康生活',
                                jsApiList:wechat_data.jsApiList
                            };
                            console.log(wechat_share_data)
                            that.$wxshare(wechat_share_data,
                                //分享成功回调
                                () => {
                                    //that.$toast.success('分享成功')
                                },
                                //分享失败回调
                                () => {
                                    //that.$toast.fail('分享失败')
                                });
                        }else{
                            that.$toast.fail(res.message)
                        }

                    })
                    .catch(err=>{
                        console.log(err)
                        //that.$toast.fail('网络错误，请稍后再试')
                    })





            },
        }
    }
</script>

<style scoped>

</style>